import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUserRole } from "./RoleContext";
import { isTokenExpired } from "./RequireAuth";
import { getCookieToken } from "../Utils/utils";
import { useEffect, useState } from "react";

// Retrieve the token from local storage
export const getToken = () => localStorage.getItem("token");

const PrivateRoutes: React.FC = () => {
  const [navigation, setNavigation] = useState<JSX.Element | null>(null);
  const location = useLocation();
  const userRole = useUserRole();
  const [token, setToken] = useState<string | null>(getToken());

  useEffect(() => {
    const checkToken = async () => {
      let currentToken: string = token ?? "";

      if (!currentToken) {
        const cookieToken = await getCookieToken();
        currentToken = cookieToken ?? "";
        setToken(cookieToken ?? null);
      }

      if (currentToken && typeof currentToken === "string") {
        const isJWTTokenExpired = isTokenExpired(currentToken);
        if (isJWTTokenExpired) {
          setNavigation(<Navigate to="/login" />);
          return;
        }

        const pathParts = location.pathname.split("/");
        const projectName = pathParts[pathParts.length - 1];
        let isAuthorized = false;

        switch (projectName) {
          case "manage-project":
          case "status":
          case "designations":
          case "admin-management":
            isAuthorized = userRole.includes("Manager");
            break;
          case "skill-list":
            isAuthorized =
              userRole.includes("Manager") ||
              userRole.includes("Human Resource");
            break;
          case "dashboard":
          default:
            isAuthorized = true;
        }

        setNavigation(
          isAuthorized ? <Outlet /> : <Navigate to="/software-dashboard" />
        );
      } else {
        setNavigation(<Navigate to="/login" />);
      }
    };
    checkToken();
  }, [location.pathname, token, userRole]);

  return navigation;
};

export default PrivateRoutes;
